export enum OperadorLogico {
    Igual = 0,
    Mayor = 1,
    Menor = 2,
    Distinto = 3,
    Verdadero = 4,
    Falso = 5
}